import React from "react";
// ANT DESIGN COMPONENTS
import { Breadcrumb } from "antd";
// NAVIGATION
import { useNavigate, useLocation } from "react-router-dom";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";

function BanksFloorConfigurationBreadcrumb() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const [t] = useTranslation("global");
  const navigate = useNavigate();
  const location = useLocation();
  const idServer = new URLSearchParams(location.search).get("idServer");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const navigateToBanks = () => {
    let searchString = "";
    if (idServer && idServer !== "") {
      searchString = `?idServer=${idServer}`;
    }
    navigate({
      pathname: "/edge-management/banks",
      search: searchString,
    });
  };

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <Breadcrumb className="">
      <Breadcrumb.Item>{t("header.edgeManagement")}</Breadcrumb.Item>
      <Breadcrumb.Item className="generalStyles__breadcrumbItemInactive" onClick={navigateToBanks}>
        Banks
      </Breadcrumb.Item>
      <Breadcrumb.Item className="generalStyles__breadcrumbItem">
        {t("general.floorsConfiguration")}
      </Breadcrumb.Item>
    </Breadcrumb>
  );
}

export default BanksFloorConfigurationBreadcrumb;
